import React, { useContext } from 'react';
import { Select } from 'antd';
import { configContext } from './config.js';
import { filterOption } from './shared.js';

const AreaSelect = ({ optionProps, ...selectProps }) => {
    const { areas } = useContext(configContext);
    return (React.createElement("span", { onMouseUp: e => {
            // workaround for this: https://github.com/ant-design/ant-design/commit/ed1959c13e938a2f1d71c315bc79cb621853ec8f
            e.stopPropagation();
        } },
        React.createElement(Select, { showArrow: true, showSearch: true, bordered: false, dropdownMatchSelectWidth: false, optionLabelProp: "label", filterOption: filterOption, ...selectProps }, areas.map(item => {
            const key = `${item.name} ${item.phoneCode}`;
            const fixedProps = {
                key,
                value: item.short,
                label: (React.createElement(React.Fragment, null,
                    item.emoji,
                    " +",
                    item.phoneCode)),
            };
            return (React.createElement(Select.Option, { ...optionProps, ...fixedProps },
                item.emoji,
                " ",
                key));
        }))));
};

export { AreaSelect, AreaSelect as default };
